import type { AnyAction } from '@reduxjs/toolkit';
import { FetchUserIdentificationsRoutine } from '../routines';
import type { IUserIdentificationsState } from '../interfaces';

export const initialState: IUserIdentificationsState = {
  isFetching: false,
  data: {},
  error: null,
};

export const userIdentificationsReducer = (
  state: IUserIdentificationsState = initialState,
  action: AnyAction,
): IUserIdentificationsState => {
  switch (action.type) {
    case FetchUserIdentificationsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchUserIdentificationsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchUserIdentificationsRoutine.FAILURE:
      return {
        ...state,
        data: {},
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
